import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { HHMT_EMAIL, HHMT_PHONE, REMOX_EMAIL, REMOX_PHONE } from 'constants';
import { datePicker } from 'helpers';
import useFxAddTransaction from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import useTheme from 'hooks/useTheme';
import React, { useEffect, useState } from 'react';
import { stringUtils } from 'utils';

const withCheckMakePaymentExpired = (Component) => {
  const CheckMakePaymentExpiredComponent = (props) => {
    const { isHHMTTheme } = useTheme();
    const { t } = useLang();
    const { showPortalModalName } = usePortalModal();

    const { mpmTimestamp, isMakePaymentAsGuest } = useFxAddTransaction();
    const { redirectToForeignExhangePath, setAddTransactionCurrentStep } =
      useFxFormAddTransactionStore();

    const [isMakePaymentExpired, setMakePaymentExpired] = useState(true);

    const onCheckMakePaymentExpired = () => {
      if (!mpmTimestamp) {
        if (isMakePaymentAsGuest) {
          setAddTransactionCurrentStep(6);
        }
        return;
      }
      const todayTimestamp = new Date(
        datePicker.convertToLocalDateTimeWithTimeZone(
          datePicker.getTodayMilliseconds(),
          'YYYY-MM-DDTHH:mm:ss'
        )
      ).getTime();
      const expiredTimestamp = new Date(
        Number(mpmTimestamp.slice(-13))
      ).getTime();
      if (todayTimestamp > expiredTimestamp) {
        showPortalModalName({
          name: PORTAL_NAME_MODAL_DEFINE.FX_MAKE_PAYMENT_EXPIRED_MODAL,
          content: stringUtils.replaceKeyword(t('popup_make_payment_expired'), [
            { key: 'email', value: isHHMTTheme ? HHMT_EMAIL : REMOX_EMAIL },
            { key: 'phone', value: isHHMTTheme ? HHMT_PHONE : REMOX_PHONE },
          ]),
          action: () => {
            redirectToForeignExhangePath();
          },
        });
      } else {
        setMakePaymentExpired(false);
      }
    };

    useEffect(() => {
      onCheckMakePaymentExpired();
    }, []);

    const newProps = {
      ...props,
      isMakePaymentExpired,
    };
    return <Component {...newProps} />;
  };
  return CheckMakePaymentExpiredComponent;
};

export default withCheckMakePaymentExpired;
